import React from 'react';
import styled from 'styled-components';

import CalendarSvg from './calendar.svg';

const CalendarIcon = styled(CalendarSvg)`
  width: ${props => props.width || '1.6rem'};
  height: ${props => props.height || '1.6rem'};
  fill: ${props => props.fill || props.theme.colors.goBrand.white};
`;

export default CalendarIcon;
